import { render, staticRenderFns } from "./LexonHiddenComponent.vue?vue&type=template&id=5ec286dc&lang=pug"
import script from "./LexonHiddenComponent.vue?vue&type=script&lang=ts"
export * from "./LexonHiddenComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec286dc')) {
      api.createRecord('5ec286dc', component.options)
    } else {
      api.reload('5ec286dc', component.options)
    }
    module.hot.accept("./LexonHiddenComponent.vue?vue&type=template&id=5ec286dc&lang=pug", function () {
      api.rerender('5ec286dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonHidden/LexonHiddenComponent.vue"
export default component.exports